<template>
  <figure class="packages-overview-header">

    <img :src="src"
         :srcset="srcset"
         :sizes="sizes"
         :alt="name"
         class="packages-overview-header__image"
         />

    <figcaption class="packages-overview-header__caption">
      <h1 class="packages-overview-header__caption-title">
        {{ amount }} mooie Voigt Travel {{ amount === 1 ? 'reis' : 'reizen' }} gevonden
      </h1>
    </figcaption>

  </figure>
</template>

<script>
const IMAGE_SIZES = [
  320,
  375,
  425,
  768,
  1024,
  1440,
];

export default {
  name: 'Header',

  props: {
    amount: {
      type: Number,
      default: 0,
    },
    headerImage: {
      type: String,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
  },

  computed: {
    sizes() {
      return IMAGE_SIZES
        .map((size, index) => {
          let formattedSize = '';

          if (index + 1 !== IMAGE_SIZES.length) {
            formattedSize += `(max-width: ${size}px) `;
          }

          formattedSize += `${size}px`;
          return formattedSize;
        })
        .join(', ');
    },

    src() {
      return `${this.headerImage}?format=webp`;
    },

    srcset() {
      return IMAGE_SIZES
        .map((size) => `${this.headerImage}?format=webp&width=${size} ${size}w`)
        .join(', ');
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '../../assets/css/helpers/mixins/breakpoints';

  .packages-overview-header {
    position: relative;
    margin: 0;
    overflow: hidden;

    &__image {
      display: block;
      width: 100%;
      object-fit: cover;

      @include tablet-and-smaller {
        height: 200px;
      }

      @include laptop-and-larger {
        height: 23.4375vw;
      }
    }

    &__caption {
      --padding-left: calc(var(--spacing-m) + var(--sidebar-width) + var(--sidebar-spacing));

      position: absolute;
      bottom: 0;
      left: 50%;
      width: 100%;
      max-width: var(--max-width);
      padding: 0 var(--spacing-m) 0 var(--padding-left);
      color: white;
      text-shadow: 0 0 3px rgba(0, 0, 0, .75);
      transform: translateX(-50%);

      &-title {
        margin-bottom: var(--spacing-m);
        font-size: 30px;
      }
    }
  }
</style>
